/* eslint-disable max-len */
import { useCallback, useEffect, useState } from 'react'
import useForm from 'tennders-common/form/hooks/useForm'
import PubSub from 'pubsub-js'
import { apiGet } from 'tennders-stracture/libs/api'
import { roundDecimals } from 'tennders-stracture/libs/utils'

type Props = {
  onFormChange: (index:number, data: Record<string, any>) => void;
  index: number
  initialErrors ?: Record<string, any>,
  vatPercentage ?: number,
  irpf ?: number,
  transactionId ?: number,
            isCreditNote ?: boolean
}

const useMultipleSalesInvoiceRow = (props : Props) => {
  const {
    onFormChange,
    index,
    isCreditNote,
    initialErrors,
    vatPercentage: initialVatPercentage
  } = props
  const { form, setform, onChange, errors } = useForm({
    initialForm: {
      concept: 'Freight',
      orderName: null,
      transactionId: null,
      route: null,
      trailerPlate: null,
      truckPlate: null,
      customerReferenceList: [],
      customerReferenceNumber: null,
      vatAmount: null,
      totalAmount: null,
      amount: null,
      vatPercentage: initialVatPercentage || '',
      clientName: null,
      extraInformation: null,
      paymentTerm: null,
      shipmentItems: []
    },
    initialErrors
  })

  const [transaction, setTransaction] = useState(null)
  const vatPercentage = form.vatPercentage ? (parseFloat(form.vatPercentage as string) / 100) : 0
  const amount = parseFloat(form.amount as unknown as string)
  const vatAmount = roundDecimals(amount * vatPercentage)
  const totalAmount = vatAmount + amount
  const fetchTransactionDetail = async (id) => apiGet(
    '/financial-transactions/' + id + '/salesLine'
  )
  const onTransactionChange = async (transaction) => {
    if (!transaction) {
      return
    }
    const data = await fetchTransactionDetail(transaction?.id ? transaction.id : transaction)
    if (data?.disabled) {
      return window.alert(data?.disabledReason)
    }
    if (data) {
      setTransaction(data)
    }
  }

  useEffect(() => {
    if (transaction && (!isCreditNote || form.transactionId !== transaction?.transactionId)) {
      setform({ ...transaction })
    }
  }, [transaction])

  useEffect(() => {
    const unsubscribe = PubSub.subscribe(`multiple-sales-invoice:${index}:change`, (msg, data) => {
      setform(prevState => ({ ...prevState, ...data }))
    })
    return () => PubSub.unsubscribe(unsubscribe)
  }, [index])

  useEffect(() => {
    if (initialVatPercentage !== null) {
      setform({ ...form, vatPercentage: initialVatPercentage })
    }
  }, [initialVatPercentage])

  useEffect(() => {
    setform({ ...form, totalAmount, vatAmount })
  }, [amount, vatPercentage])

  useEffect(() => {
    if (onFormChange) {
      onFormChange(index, {
        ...form,
        vatAmount,
        totalAmount
      })
    }
  }, [
    form,
    index,
    amount,
    vatPercentage,
    onFormChange
  ])

  return {
    transaction,
    form,
    onChange,
    setTransaction,
    onTransactionChange,
    errors,
    vatAmount,
    totalAmount

  }
}

export default useMultipleSalesInvoiceRow
